module.exports = new __parcel__URL__("shop_cosmetics_button_inactive.592a996f.png").toString();